module.exports = __webpack_public_path__ + "img/totalmeetings300.2244add4.png";